
import React, { Component } from 'react'
import { Form, Button, FormInstance, Input } from 'antd'
import { withTranslation, WithTranslationProps } from 'react-i18next'

interface FormProps {
    onSearch: (values: any) => void
    onReset: () => void
}

class SearchForm extends Component<FormProps & WithTranslationProps> {

    formRelf;
    constructor(props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    onSearch = (values) => {
        const { onSearch } = this.props;
        console.log(values);
        onSearch(values);
    }

    onReset = () => {
        this.formRelf.current!.resetFields();
        this.props.onReset();
    }

    render () {
        
        const i18n = this.props.i18n;
        return (
            <Form
                ref={this.formRelf}
                className="searchUser-form"
                onFinish={this.onSearch}
                >
                <div className="searchItem">
                    <Form.Item label={i18n?.t('name')} name="nickname">
                        <Input />
                    </Form.Item>
                    <div>
                        <Button 
                            type="primary"
                            htmlType="submit"
                            className="margin-right-20"
                            >{i18n?.t('search')}</Button>
                        <Button onClick={this.onReset}>{i18n?.t('reset')}</Button>
                    </div>
                </div>
                
            </Form>
        )
    }
}

export default withTranslation()(SearchForm)